(function() {
    angular
        .module("apiModule")
        .config(apiRouter)

    apiRouter.$inject = [
        "$stateProvider",
        "$urlRouterProvider",
        "$locationProvider"
    ]

    function apiRouter(
        $stateProvider,
        $urlRouterProvider,
        $locationProvider
    ){

        $stateProvider.state("api", {
            url: "/customers/:customer_id/api/",
            templateUrl: "app/components/api/api.view.html",
            controller : "ApiController"
        })
        .state("api-documentation", {
            url: "/customers/:customer_id/api/configs/:api_config_id/documentation?group&section&format",
            templateUrl: "app/components/api/docs.view.html",
            controller : "ApiDocsController"
        })
        .state("wzdx-documentation", {
            // 2025-02-22 - This is not correct
            url: "/customers/:customer_id/api/documentation-wzdx?group&section&format",
            templateUrl: "app/components/api/docs-wzdx.view.html",
            controller : "ApiDocsController"
        })

        $urlRouterProvider.otherwise("/")

        $locationProvider.html5Mode(true)
    }
})()
